import { createRouter, createWebHistory } from 'vue-router'
import RankTable from '../components/RankTable.vue'
import MarketData from '../components/MarketData.vue'
import TestChart from "@/components/TestChart.vue";
import DataComparison from "@/components/DataComparison.vue";
import NewGameList from "@/components/NewGameList.vue";
import GameTask from "@/components/GameTask.vue";
import WechatSub from "@/components/WechatSub.vue";  // 请确保已创建此组件
import RankTableKS from "@/components/RankTableKS.vue";
import KSMarketData from '../components/KSMarketData.vue'
import KSDataComparison from "@/components/KSDataComparison.vue";

const routes = [
    {
        path: '/',
        name: 'RankTable',
        component: RankTable,
        meta: { title: '互动玩法榜' }
    },
    {
        path: '/ks',
        name: 'RankTableKS',
        component: RankTableKS,
        meta: { title: '互动玩法榜' }
    },
    {
        path: '/market_data',
        name: 'MarketData',
        component: MarketData,
        meta: { title: '互动玩法榜' }
    },
    {
        path: '/ks_market_data',
        name: 'KSMarketData',
        component: KSMarketData,
        meta: { title: '互动玩法榜' }
    },
    {
        path: '/test_chart',
        name: 'TestChart',
        component: TestChart,
        meta: { title: '互动玩法榜' }
    },
    {
        path: '/data_comparison',
        name: 'DataComparison',
        component: DataComparison,
        meta: { title: '互动玩法榜' }
    },
    {
        path: '/ks_data_comparison',
        name: 'KSDataComparison',
        component: KSDataComparison,
        meta: { title: '互动玩法榜' }
    },
    {
        path: '/new_game_info',
        name: 'NewGameList',
        component: NewGameList,
        meta: { title: '互动玩法榜' }
    },
    {
        path: '/game_task',
        name: 'GameTask',
        component: GameTask,
        meta: { title: '玩法活动数据' }
    },
    {
        path: '/wechat/subscribe',
        name: 'Subscribe',
        component: WechatSub,
        meta: { title: '微信用户订阅功能' }
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

// 设置页面标题
router.beforeEach((to, from, next) => {
    // 获取meta中的title并设置为document.title
    if (to.meta.title) {
        document.title = to.meta.title;
    } else {
        document.title = 'Default Title';  // 默认标题
    }
    next();
});

export default router
